import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store";

const useHttpSection = (props) => {
  const { page, notValidPageHandler, getPageNumber, link, Search } = props;
  const token = useSelector((state) => state.auth.Token);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = () => {
      return fetch(`http://213.233.177.17:8022/${link}/?page=${page}&&q=${Search}`, {
        method: "GET",
        // body: body,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else {
            if (data.detail !== "Invalid page.") {
              getPageNumber(Math.ceil(data.count / 10));
              if (Math.ceil(data.count / 10) === page) {
                notValidPageHandler(true);
              }
              console.log(data.results);
              setData(data.results);
              setIsLoading(false);
            }
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    };
    fetchData();
  }, [page, Search, dispatch, link, getPageNumber, notValidPageHandler, token]);
  return {
    isLoading: isLoading,
    data: data,
  };
};
export default useHttpSection;
